<template>
  <message-search
    :add-and-filter-persmission="canManageMessage"
    :default-role="user.profile.roleid"
    :delete-message="deleteMessage"
    :download-file="downloadFile"
    :get-messages="getMessages"
  />
</template>

<script>
//Third Party
import { mapState } from 'vuex';

//Component Libs
import { MessageSearch } from 'operations';

//services
import service from '@/services/common/dashboard.api.js';
import { deleteMessage as _deleteMessage } from '@/services/common/message.api.js';

//store
import { name as userModuleName } from '@/store/modules/user';

export default {
  name: 'MainMessageWrapper',
  components: {
    MessageSearch,
  },
  computed: {
    ...mapState(userModuleName, ['user']),
    canManageMessage() {
      return this.userHasPermissions('rempro.home.message');
    },
  },
  methods: {
    getMessages(params) {
      return service.searchMessages(params);
    },
    downloadFile(documentId) {
      return service.downloadDocumentByAttachmentId(documentId);
    },
    deleteMessage(id) {
      return _deleteMessage(id);
    },
  },
};
</script>
